import { useEffect, useState } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import PhoelynxPlatform from './components/PhoelynxPlatform'
import ProjectsPage from './components/ProjectsPage'
import BoutiquePage from './components/BoutiquePage'
import CartPage from './components/CartPage'
import CheckoutPage from './components/CheckoutPage'
import OrderResultPage from './components/OrderResultPage'
import FormationsPage from './components/FormationsPage'
import CompetitionsPage from './components/CompetitionsPage'
import PrivacyPolicy from './components/PrivacyPolicy'
import LegalNotice from './components/LegalNotice'
import TermsOfService from './components/TermsOfService'
import MaintenancePage from './components/MaintenancePage'
import GameLoader from './components/GameLoader'
import { useMaintenanceStatus } from './hooks/useMaintenanceStatus'
import { useAnalytics } from './hooks/useAnalytics'

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Si il y a un hash, attendre que la page se charge puis scroller vers l'élément
      setTimeout(() => {
        const element = document.getElementById(hash.slice(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // Sinon, scroller en haut de page
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  const { isMaintenanceMode, maintenanceMessage, loading } = useMaintenanceStatus();
  useAnalytics();
  const [showGameLoader, setShowGameLoader] = useState(true);

  // Afficher le loader de jeu en premier
  if (showGameLoader) {
    return <GameLoader onComplete={() => setShowGameLoader(false)} />;
  }

  // Afficher un loader pendant la vérification du statut de maintenance
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <div className="relative mb-4">
            <img
              src="/assets/logos/Phoelynx_Transparent.webp"
              alt="Phoelynx France"
              className="w-24 h-24 mx-auto object-contain animate-pulse hover:animate-bounce transition-all duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-red-500/20 to-sky-500/20 rounded-full animate-ping"></div>
          </div>
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-3 text-sm text-gray-400 animate-pulse">Chargement...</p>
        </div>
      </div>
    );
  }

  // Si le mode maintenance est activé, afficher uniquement la page de maintenance
  if (isMaintenanceMode) {
    return <MaintenancePage message={maintenanceMessage} />;
  }

  // Sinon, afficher l'application normale
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<PhoelynxPlatform />} />
        <Route path="/projets" element={<ProjectsPage />} />
        <Route path="/boutique" element={<BoutiquePage />} />
        <Route path="/panier" element={<CartPage />} />
        <Route path="/commande" element={<CheckoutPage />} />
        <Route path="/boutique/commande/succes" element={<OrderResultPage success={true} />} />
        <Route path="/boutique/commande/annulee" element={<OrderResultPage success={false} />} />
        <Route path="/formations" element={<FormationsPage />} />
        <Route path="/competitions" element={<CompetitionsPage />} />
        <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
        <Route path="/mentions-legales" element={<LegalNotice />} />
        <Route path="/conditions-utilisation" element={<TermsOfService />} />
      </Routes>
    </>
  )
}

export default App